import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../api/axios";

const API_URL = "https://api.ozilcrm.com/api";

// Helper function to set auth headers
const getAuthHeaders = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  if (user && user.token) {
    return {
      Authorization: `Bearer ${user.token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    };
  }
  return {};
};

// export const registerUser = createAsyncThunk("auth/createuser", async (userData, { rejectWithValue }) => {
//   try {
//     // const response = await axios.post(`${API_URL}/register`, userData);

//     const response = await api.post(`/franchisee-users/c`, userData, {
//       headers: getAuthHeadersapiKey(),
//     });

//     if (response.data.token) {
//       localStorage.setItem("user", JSON.stringify(response.data));
//     }
//     return response.data;
//   } catch (error) {
//     return rejectWithValue(error.response.data);
//   }
// });
export const fetchUsers = createAsyncThunk(
  "franchisee-users/userlist",
  async ({ filterData, page = 1 }, { rejectWithValue }) => {
    try {
      const response = await api.post("/franchisee-users/userlist", {
        filterData,
        page,
      });

      return {
        data: response.data.data.data,
        page: response.data.data.current_page,
        totalPages: response.data.data.last_page,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const createUser = createAsyncThunk("franchisee-users/createuser", async (userData, { rejectWithValue }) => {
  try {
    const response = await api.post(`/franchisee-users/createuser`, userData, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const fetchuserdetails = createAsyncThunk(
  "franchisee-users/fetchUserDetails",
  async (userID, { rejectWithValue }) => {
    try {
      const response = await api.post(`/franchisee-users/edit/${userID}`, {}, { headers: getAuthHeaders() });

      return response.data.data; // Must return clean user data
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to fetch user data",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);


// export const PasspordRequestUpdate = createAsyncThunk(
//   "passport/savepassport",
//   async ({ postData }, { rejectWithValue }) => {
//     try {
//       // API call to validate fare
//       const response = await api.post(`/passport/savepassport`, postData, { headers: getAuthHeaders() });

//       return { data: response.data };
//     } catch (error) {
//       return rejectWithValue({
//         message: error.message || "Failed to validate fare",
//         status: error.response?.status,
//         data: error.response?.data,
//       });
//     }
//   }
// );

export const PasspordRequestUpdate = createAsyncThunk("passport/savepassport", async (submitFormData, { rejectWithValue }) => {
  try {
    const response = await api.post(`/passport/savepassport`, submitFormData, {
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "multipart/form-data", // Important for file upload
      },
    });

    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to fetch user data",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});



export const GetPassportRequests = createAsyncThunk(
  "/passport/list",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/passport/list`,
        {},
        { headers: getAuthHeaders() } // ✅ correct
      );
      return response.data;
    } catch (error) {
      rejectWithValue({
        message: error.message || "Failed to fetch user data",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const updateUser = createAsyncThunk(
  "franchisee-users/updateUser",
  async ({ id, userData }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/franchisee-users/update/${id}`, userData, { headers: getAuthHeaders() });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteUser = createAsyncThunk("users/deleteUser", async (id, { rejectWithValue }) => {
  try {
    await axios.delete(`${API_URL}/users/${id}`, {
      headers: getAuthHeaders(),
    });
    return id;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});
export const FetchCountry = createAsyncThunk("fetchcountry", async (FormData, { rejectWithValue }) => {
  try {
    const response = await api.post(`/country`, FormData, { headers: getAuthHeaders() });
    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});

export const FetchState = createAsyncThunk("fetchstate", async (FormData, { rejectWithValue }) => {
  try {
    const response = await api.post(`/states`, FormData, { headers: getAuthHeaders() });
    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});

export const FetchCity = createAsyncThunk("fetchcity", async (FormData, { rejectWithValue }) => {
  try {
    const response = await api.post(`/cities`, FormData, { headers: getAuthHeaders() });
    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
const initialState = {
  users: [],
  singleUser: null,
  status: "idle",
  formStatus: "idle",
  error: null,
  page: 1,
  totalPages: 1,
  hasMore: true,
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    resetStatus: (state) => {
      state.status = "idle";
      state.formStatus = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.users = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchuserdetails.pending, (state) => {
        state.status = "loading";
        state.singleUser = null;
      })
      .addCase(fetchuserdetails.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.singleUser = action.payload; // <--- Store user here
      })
      .addCase(fetchuserdetails.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(createUser.pending, (state) => {
        state.formStatus = "loading"; // 👈 ADD
      })

      .addCase(createUser.fulfilled, (state, action) => {
        state.formStatus = "succeeded"; // 👈 ADD

        if (!state.users || !state.users.data) {
          state.users = { data: [], page: 1, totalPages: 1 };
        }

        const newUser = action.payload?.data;
        if (newUser) {
          state.users.data.unshift(newUser);
        }
      })

      .addCase(createUser.rejected, (state, action) => {
        state.formStatus = "failed"; // 👈 ADD
        state.error = action.payload;
      })

      .addCase(updateUser.fulfilled, (state, action) => {
        const payload = action.payload;

        // If API returned no user object, skip list update
        if (!payload || !payload.data) {
          console.warn("Update API returned no user data, skipping list update");
          return;
        }

        const updatedUser = payload.data;

        if (state.users?.data && updatedUser?.id) {
          const index = state.users.data.findIndex((user) => user.id === updatedUser.id);
          if (index !== -1) {
            state.users.data[index] = updatedUser;
          }
        }

        state.singleUser = updatedUser;
      })

      .addCase(deleteUser.fulfilled, (state, action) => {
        state.users = state.users.filter((user) => user.id !== action.payload);
      })
      .addCase(FetchCountry.pending, (state) => {
        state.resultLoading = true;
        state.error = null;
      })
      .addCase(FetchCountry.fulfilled, (state, action) => {
        state.resultLoading = false;
        state.FetchCountry = action.payload.data;
      })
      .addCase(FetchCountry.rejected, (state, action) => {
        state.resultLoading = false;
        state.error = action.payload?.message || "Failed to fetch results";
      })
      .addCase(FetchState.pending, (state) => {
        state.resultLoading = true;
        state.error = null;
      })
      .addCase(FetchState.fulfilled, (state, action) => {
        state.resultLoading = false;
        state.FetchState = action.payload.data;
      })
      .addCase(FetchState.rejected, (state, action) => {
        state.resultLoading = false;
        state.error = action.payload?.message || "Failed to fetch results";
      })
      .addCase(FetchCity.pending, (state) => {
        state.resultLoading = true;
        state.error = null;
      })
      .addCase(FetchCity.fulfilled, (state, action) => {
        state.resultLoading = false;
        state.FetchCity = action.payload.data;
      })
      .addCase(FetchCity.rejected, (state, action) => {
        state.resultLoading = false;
        state.error = action.payload?.message || "Failed to fetch results";
      });
  },
});

export const selectAllUsers = (state) => state.users.users;
export const selectUsersStatus = (state) => state.users.status;
export const selectUsersError = (state) => state.users.error;
export const FetchAllCountry = (state) => state.users.FetchCountry;
export const FetchAllState = (state) => state.users.FetchState;
export const FetchAllCity = (state) => state.users.FetchCity;

export const selectSingleUser = (state) => state.users.singleUser;
export const { resetStatus } = usersSlice.actions;
export default usersSlice.reducer;
